import React from 'react';
import '../Pages/Footer.css';

export default function Footer() {
  return (
    <>
      <footer>
        <div class="container-fluid p-0">
          <div class="row">
            <div class="col-md-6">
              <div class="footer_description">
                <div class="footer_description_text">
                  <h3>Like what you see?
                    <br />Let's start a conversation</h3>
                  <div class="footer_description_button">
                    <button>GET IN TOUCH</button>
                  </div>
                  <div class="footer_description_address">
                    <h4>Visit us at</h4>
                    <div class="footer_description_address_country">
                      <ul>
                        <li>
                          <div class="footer_description_address_country_flag">
                            <img src="https://www.unifiedinfotech.net/assets/images/icon/Flag-USA.svg" />
                          </div>
                          <div class="footer_description_address_country_pincode">
                            <a>79 Madison Avenue, New York, NY 10016</a>
                          </div>
                        </li>
                        <li>
                          <div class="footer_description_address_country_flag">
                            <img src="https://www.unifiedinfotech.net/assets/images/icon/Flag-India.svg" />
                          </div>
                          <div class="footer_description_address_country_pincode">
                            <a>DN 53, Salt Lake City, Sec V, Kol-700091</a>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="footer_description_social_media_links">
                      <ul>
                        <li>
                          <i class="bi bi-twitter"></i>
                        </li>
                        <li>
                          <i class="bi bi-facebook"></i>
                        </li>
                        <li>
                          <i class="bi bi-linkedin"></i>
                        </li>
                        <li>
                          <i class="bi bi-instagram"></i>
                        </li>
                        <li>
                          <i class="bi bi-behance"></i>
                        </li>
                        <li>
                          <i class="bi bi-dribbble"></i>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="footer_banner">
              </div>
            </div>
          </div>
          <div className='footer_bottom'>
            <div className='footer_bottom_text'>
              <center>© 2023 All Rights Reserved. Design By <a href='https://www.instagram.com/piyushpandey5241/'>Piyush Pandey</a></center>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
